export class UniqueUserNameValidationRequest {
    userName: string;
    userID: number;
}